var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c("div", { staticClass: "row q-mb-md" }, [
        _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
          _c(
            "div",
            { staticClass: "q-display-1 text-secondary" },
            [
              _c("q-icon", {
                staticClass: "q-mb-sm",
                attrs: { name: "far fa-sign" }
              }),
              _vm._v(" " + _vm._s(_vm.$t(_vm.title_trails)) + "\n\t\t\t")
            ],
            1
          )
        ])
      ]),
      _c(
        "q-tabs",
        {
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "basic-data",
              label: _vm.$t("basic_data")
            },
            slot: "title"
          }),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTab("trainings"),
                expression: "showTab('trainings')"
              }
            ],
            attrs: {
              slot: "title",
              name: "trainings",
              label: _vm.$t(_vm.getLabel("title_trainings", "trainings"))
            },
            slot: "title"
          }),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTab("live_classes"),
                expression: "showTab('live_classes')"
              }
            ],
            attrs: {
              slot: "title",
              name: "live-classes",
              label: _vm.$t(_vm.getLabel("title_live_classes", "live_classes"))
            },
            slot: "title"
          }),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showModule("presential"),
                expression: "showModule('presential')"
              }
            ],
            attrs: {
              slot: "title",
              name: "presentials",
              label: _vm.$t(_vm.getLabel("title_presential", "presential"))
            },
            slot: "title"
          }),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTab("webcasts"),
                expression: "showTab('webcasts')"
              }
            ],
            attrs: {
              slot: "title",
              name: "webinars",
              label: _vm.$t(_vm.getLabel("title_webcasts", "webcasts"))
            },
            slot: "title"
          }),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTab("podcasts"),
                expression: "showTab('podcasts')"
              }
            ],
            attrs: {
              slot: "title",
              name: "podcasts",
              label: _vm.$t(_vm.getLabel("title_podcasts", "podcasts"))
            },
            slot: "title"
          }),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTab("news"),
                expression: "showTab('news')"
              }
            ],
            attrs: {
              slot: "title",
              name: "news",
              label: _vm.$t(_vm.getLabel("title_news", "news"))
            },
            slot: "title"
          }),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTab("library"),
                expression: "showTab('library')"
              }
            ],
            attrs: {
              slot: "title",
              name: "libraries",
              label: _vm.$t(_vm.getLabel("title_library", "library"))
            },
            slot: "title"
          }),
          _vm.useCommentsTrail
            ? _c("q-tab", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showTab("comments"),
                    expression: "showTab('comments')"
                  }
                ],
                attrs: {
                  slot: "title",
                  name: "comments",
                  label: _vm.$t("comments")
                },
                slot: "title"
              })
            : _vm._e(),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTab("configure_and_publish"),
                expression: "showTab('configure_and_publish')"
              }
            ],
            attrs: {
              slot: "title",
              name: "configure_and_publish",
              label: _vm.$t("configure_and_publish")
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            { attrs: { "keep-alive": "", name: "basic-data" } },
            [_c("basic-data", { attrs: { manage_trails: _vm.manageTrails } })],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "trainings" } },
            [_c("trainings", { attrs: { manage_trails: _vm.manageTrails } })],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "presentials" } },
            [_c("presentials", { attrs: { manage_trails: _vm.manageTrails } })],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "webinars" } },
            [_c("webinars", { attrs: { manage_trails: _vm.manageTrails } })],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "live-classes" } },
            [
              _c("live-classes", { attrs: { manage_trails: _vm.manageTrails } })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "podcasts" } },
            [_c("podcasts", { attrs: { manage_trails: _vm.manageTrails } })],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "libraries" } },
            [_c("libraries", { attrs: { manage_trails: _vm.manageTrails } })],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "news" } },
            [_c("news", { attrs: { manage_trails: _vm.manageTrails } })],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "comments" } },
            [
              _c("comments", {
                attrs: { origin: "trails", manager: _vm.manageTrails }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "configure_and_publish" } },
            [
              _c("configure-and-publish", {
                attrs: { manage_trails: _vm.manageTrails },
                on: { duplicate: _vm.changeTab }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }